import { useNavigate } from "react-router-dom"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"
import { SERVICE_CENTER_ADMIN_ROUTE, SERVICE_CENTER_MESSAGES_ROUTE } from "../../../../../constants/routes"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { CreateUpdateMessageForm } from "../../../../merchant/admin/messages/components/CreateUpdateMessageForm"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { useCreateServiceCenterMessageFlow } from "../components/serviceCenterMessagesHooks"
import { SERVICE_CENTER_CHANNEL_OPTIONS } from "../serviceCenterChannelOptions"

export function ServiceCenterCreateMessage() {
    const navigate = useNavigate()

    const { formRef, handleSaveClick, handleSubmit } = useCreateServiceCenterMessageFlow(() =>
        navigate(SERVICE_CENTER_MESSAGES_ROUTE),
    )

    return (
        <>
            <LocalizedStrict id="create-message-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.MESSAGE_CREATE}
                    title="Create message"
                    rightElement={
                        <LocalizedStrict id="create-message-save-button">
                            <StandardButton type="submit" onClick={handleSaveClick}>
                                Create
                            </StandardButton>
                        </LocalizedStrict>
                    }
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="service-center-nav-item-home">
                            <BreadcrumbLink to={SERVICE_CENTER_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="service-center-admin-nav-item-communication">
                            <Breadcrumb>Communication</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="service-center-nav-item-messages">
                            <BreadcrumbLink to={SERVICE_CENTER_MESSAGES_ROUTE}>Messages</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="nav-item-create-message-header">
                            <Breadcrumb>Create message</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <CreateUpdateMessageForm
                ref={formRef}
                mode="create"
                channelOptions={SERVICE_CENTER_CHANNEL_OPTIONS}
                defaultChannels={[]}
                onSubmit={handleSubmit}
            />
        </>
    )
}
